import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppConfigurationService {
  constructor() {}

  get spaBaseUrl(): string {
    return environment.spaBaseUrl;
  }

  get apiBaseUrl(): string {
    return environment.apiBaseUrl;
  }

  get cotacaoOnline(): string {
    return environment.cotacaoOnline;
  }
}
